
import { useAnimation } from "framer-motion";
import { useState, useEffect } from "react";
import { MainMenu } from "@/components/MainMenu";
import { useIsMobile } from "@/hooks/use-mobile";
import { AnimatedBackground } from "@/components/home/AnimatedBackground";
import { LoadingScreen } from "@/components/home/LoadingScreen";
import { AnimatedLogo } from "@/components/home/AnimatedLogo";
import { MenuButton } from "@/components/home/MenuButton";
import { QuotationSearch } from "@/components/QuotationSearch";

export const PublicHome = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const logoControls = useAnimation();
  const isMobile = useIsMobile();

  useEffect(() => {
    // Initial loading animation
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      logoControls.start({
        rotateY: 360,
        opacity: 0,
        transition: { duration: 0.3 }
      });
    } else {
      logoControls.start({
        rotateY: 0,
        opacity: 1,
        transition: { duration: 0.3 }
      });
    }
  }, [isMenuOpen, logoControls]);

  if (initialLoading) {
    return <LoadingScreen />;
  }

  return (
    <div 
      className="relative min-h-screen w-full overflow-hidden flex flex-col"
      style={{
        backgroundColor: "white",
        backgroundImage: "linear-gradient(rgba(255,255,255,0.5) 50%, rgba(0,0,0,0.02) 50%)",
        backgroundSize: "4px 4px"
      }}
    >
      <MenuButton onClick={() => setIsMenuOpen(!isMenuOpen)} />
      <AnimatedLogo logoControls={logoControls} isMobile={isMobile} />

      {/* Search Input */}
      <div className="fixed top-4 right-4 z-30 flex gap-2 w-full max-w-[360px] px-4">
        <QuotationSearch />
      </div>

      <MainMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      <AnimatedBackground isMenuOpen={isMenuOpen} />
      
      {/* Footer */}
      <footer className="w-full py-4 px-6 mt-auto text-center text-sm text-gray-500 relative z-20">
        <p>
          Desenvolvido por{" "}
          <a 
            href="https://lightmachine.digital/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#0073B7] hover:text-[#004080] transition-colors"
          >
            Light Machine
          </a>
        </p>
      </footer>
    </div>
  );
};
